import {memo} from 'react';
import {Avatar} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {regular} from "@fortawesome/fontawesome-svg-core/import.macro";
import {size} from "@material-tailwind/react/types/components/avatar";

interface BrokerAvatarProps {
    image: string,
    size?: size
    className?: string,
}

const UserAvatar = ({image, className, size = "md"}: BrokerAvatarProps) => {
    return image ? <Avatar size={size}
                           className={`border border-blue-gray-50 dark:border-blue-gray-500 bg-blue-gray-50/50 dark:bg-blue-gray-700 object-contain w-8 h-8 ${className ?? ''}`}
                           src={`${window.location.origin}/images/users/${image}`}/>
        : <FontAwesomeIcon
            className="text-gray-900 dark:text-gray-500 h-5 w-5" icon={regular("user")}/>;
}

export default memo(UserAvatar);
